import React from "react"
import { Helmet } from "react-helmet"
import gql from "graphql-tag"
import styled from "@emotion/styled"
import { useQuery } from "@apollo/client"
import { useParams } from "react-router-dom"
import { LoadingPage } from "../UI"
import { MaxWidth } from "../UI/Containers"
import PageHeader from "./PageHeader"
import Contact from "./Contact"
import Operations from "./Operations"
import Iframe from "../UI/Iframe"
import { ApartmentContent } from "./InterestApartment";
import { BusinessContent } from "./InterestBusiness"
import { ParkingContent } from "./InterestParking"
import default_bg from "../img/default-bg.jpg"

const PageContent = props => {
  const page = props.data?.page;
  const imageUrl = page.image.url ? page.image.url : default_bg;

  if (!page) {
    return null;
  }

  return (
    <div>
      <Helmet>
        <meta charSet="utf-8" />
        <title>{page.title}</title>
      </Helmet>
      <PageHeader pageData={{ ...page, image: { ...page.image, url: imageUrl } }} />
      {(page.template === "CONTACT" && <Contact page={page} />) ||
        (page.template === "INTEREST" && (
          <ApartmentContent page={page} />
        )) ||
        (page.template === "INTERESTB" && (
          <BusinessContent page={page} />
        )) ||
        (page.template === "INTERESTP" && (
          <ParkingContent page={page} />
        )) ||
        ((page.template === "FREE" ||
          page.template === "SALE" ||
          page.template === "OPS") && (
            <Operations page={page} template={page.template} />
          )) || (
          <React.Fragment>
            <PageSection>
              <MaxWidth
                dangerouslySetInnerHTML={{
                  __html: page.content,
                }}
              />
              {page.iframeUrl && (
                <MaxWidth>
                  <Iframe src={page.iframeUrl} />
                </MaxWidth>
              )}
            </PageSection>
            {page.boxSet &&
              page.boxSet.map((box, index) => {
                return (
                  <PageSection key={index}>
                    <MaxWidth>
                      <h1>{box.title}</h1>
                      {box.content && (
                        <div
                          dangerouslySetInnerHTML={{
                            __html: box.content,
                          }}
                        />
                      )}
                    </MaxWidth>
                    {box.iframeUrl && (
                      <MaxWidth>
                        <Iframe title={box.title} src={box.iframeUrl} />
                      </MaxWidth>
                    )}
                  </PageSection>
                );
              })}
          </React.Fragment>
        )}
    </div>
  );
}

const Page = () => {
  const { slug } = useParams();

  const { loading, error, data } = useQuery(query, {
    variables: { slug },
  });

  if (loading) return <LoadingPage />;
  if (error) {
    console.error("Error fetching page:", error);
    return <p>Error loading page.</p>;
  }
  return <PageContent data={data} />;
}

const query = gql`
    query Page($slug: String) {
        page(slug: $slug) {
            headTitle
            excerpt
            headLink
            headLinkText
            title
            content
            template
            iframeUrl
            image {
                url
            }
            boxSet {
                title
                content
                iframeUrl
            }
        }
    }
`

export const PageSection = styled("section")`
    display: block;
    width: 100%;
    line-height: 1.5em;
    &:nth-of-type(even) {
        background: ${props => props.theme.colors.accent};
    }
    padding: ${props => props.theme.spacing.default};
    ${props => props.theme.bp.below.lg} {
        padding: 2rem;
    }
    > div {
        padding: 0px 150px;
        ${props => props.theme.bp.below.lg} {
            padding: 0px;
    }
    a{
        text-decoration:underline;
    }
    table{
        width:100%;
        border-collapse:collapse;
        th,td{
            margin:0;
            border:0;
            padding:.5rem;
            text-align:left;
        }
        tr:nth-of-type(even){
            background:white;
        }
        tr:nth-of-type(odd){
            background:#f1f1f1;
        }
        th{
            background: ${props => props.theme.colors.secondary};
            color:white;
        }
    }

    table.invoice-list{
        ${props => props.theme.bp.below.sm} {
            display:block;
            thead{
                display:none;
            }
            tbody{
                display:block;
            }
            tr{
                background:white;
                margin-bottom:1.5rem;
                display:flex;
                flex-direction:column;
                font-size:13px;
                td:nth-of-type(1){
                    background: ${props => props.theme.colors.secondary};
                    color:white;
                    font-size:16px;
                    font-weight:700;
                }
                td:nth-of-type(2),
                td:nth-of-type(3),
                td:nth-of-type(4){
                    display:flex;
                    &::before{
                        font-weight:700;
                        width:30%;
                    }
                }
                td:nth-of-type(2)::before{
                        content:"Adress";
                    
                }
                td:nth-of-type(3)::before{
                        content:"Postnr + Ort";
                }
                td:nth-of-type(4)::before{
                        content:"Mail för PDF";
                }
            }
        }
    }
`

export default Page;
